import { useEffect } from 'react';
import { BrowserRouter, Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { HelpHeader } from '../components/layout/HelpHeader';
import { useProfilePreference } from '../hooks/useProfilePreference';
import { profileFromSegment } from '../lib/routes';
import { ArticlePage } from '../pages/ArticlePage';
import { FAQPage } from '../pages/FAQPage';
import { HomePage } from '../pages/HomePage';
import { ProfileHomePage } from '../pages/ProfileHomePage';
import { SearchPage } from '../pages/SearchPage';
import type { Profile } from '../types/profile';

export function App() {
  return (
    <BrowserRouter basename={import.meta.env.VITE_HELP_BASENAME || '/'}>
      <AppShell />
    </BrowserRouter>
  );
}

function AppShell() {
  const { profile, setProfile } = useProfilePreference();
  return (
    <>
      <RouteProfileSync currentProfile={profile} onProfileChange={setProfile} />
      <HelpHeader profile={profile} onProfileChange={setProfile} />
      <Routes>
        <Route path="/" element={<HomePage onChooseProfile={setProfile} />} />
        <Route path="/aluno" element={<ProfileHomePage profile="student" />} />
        <Route path="/mentor" element={<ProfileHomePage profile="mentor" />} />
        <Route path="/owner" element={<ProfileHomePage profile="owner" />} />
        <Route path="/:profileSegment/:category/:articleSlug" element={<ArticlePage />} />
        <Route path="/busca" element={<SearchPage profile={profile} />} />
        <Route path="/faq" element={<FAQPage profile={profile ?? 'student'} />} />
        <Route path="/inicio" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

function RouteProfileSync({ currentProfile, onProfileChange }: { currentProfile?: Profile; onProfileChange: (profile: Profile) => void }) {
  const location = useLocation();
  const firstSegment = location.pathname.split('/').filter(Boolean)[0];
  const routeProfile = profileFromSegment(firstSegment);

  useEffect(() => {
    if (routeProfile && routeProfile !== currentProfile) onProfileChange(routeProfile);
  }, [routeProfile, currentProfile, onProfileChange]);

  return null;
}

function NotFound() {
  return (
    <main className="page-shell empty-state">
      <p className="eyebrow">404</p>
      <h1>Não encontramos esta página.</h1>
      <Link className="button-link" to="/">Ir para o Centro de Ajuda</Link>
    </main>
  );
}
